import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { environment } from '@env/environment';

import { FinancialCalculations, FinancialReview, FinancialSummary } from '@app/models';

@Injectable({
  providedIn: 'root',
})
export class FinancialService {
  /** ReplaySubject for financial calculations so that the FinancialReviewComponent can calculate values and share them with FinancialRateComponent  */
  financialCalculations: ReplaySubject<FinancialCalculations> = new ReplaySubject<FinancialCalculations>(1);

  /** ReplaySubject for saving financial review immediately before attempting to rate and finalize.  */
  financialReviewData: ReplaySubject<FinancialReview> = new ReplaySubject<FinancialReview>(1);

  constructor(private http: HttpClient) {}

  saveFinancialReview(appId: number, financialReview: FinancialReview): Observable<any> {
    const payload = { applicationId: appId, ...financialReview };
    return this.http.post<any>(`${environment.apiUrl}/api/agency/Application/SaveFinancialReview`, payload);
  }

  getFinancialReview(appId: number): Observable<FinancialReview> {
    return this.http.get<FinancialReview>(
      `${environment.apiUrl}/api/agency/Application/GetFinancialReview?appId=${appId}`
    );
  }

  getFinancialSummary(appId: number): Observable<FinancialSummary> {
    return this.http.get<FinancialSummary>(
      `${environment.apiUrl}/api/agency/Application/GetFinancialSummary?appId=${appId}`
    );
  }
}
